<template>
    <div id="dashboard-page" class="mb-5">
        <b-row class="mb-5 mt-2">
          <!-- <b-col md='8' class="mb-2">
            <div class="d-flex">
              <span class="mb-4 mt-2 dashboard-border"><router-link to="/dashboard">ERP Dashboard</router-link></span>
              <span class="ml-4 mb-4 mt-2 dashboard-border active"><router-link to="/vehicle">{{$route.name}}</router-link></span>
            </div>
          </b-col> -->
          <b-col cols="12" >
            <b-card id="dashboard-chart-sales">
              <b-row>
                <b-col md="12">
                  <b-row>
                    <b-col md="3">
                      <p style="color:#495057; font-weight:bold!important;">Statistics</p>
                    </b-col>
                    <b-col md="9">
                      <p class="float-right" style="color:#90A4AE; font-weight:bold; font-size:13.5px!important;">Latest sales</p>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="12 mx-4">
                  <b-row>
                    <b-col md="1 vrhicle">
                      <router-link to="#">
                        <i class="icon-sales text-center"></i>
                      </router-link>
                        <!--<b-button variant="light" href="/#">d</b-button>
                        <font-awesome-icon icon="tags" style="font-size:35px!important; margin-top:12px!important;" />-->
                    </b-col>
                    <b-col md="2 vrhicle">
                      <router-link to="#">
                        <p class="text-black" style="font-size:22px!important;">{{this.model.totalSales}}<p style="font-size:15px!important; color:#495057; margin-top:-10px!important;">Total Sales</p>
                      </router-link>
                    </b-col>
                    <b-col md="1 vrhicle">
                      <router-link to="/sales/daily-sales">
                        <i class="icon-daily text-center"></i>
                      </router-link>
                    </b-col>
                    <b-col md="2 vrhicle">
                      <router-link to="/sales/daily-sales">
                        <p class="text-black" style="font-size:22px!important;">{{this.model.daily}}<p style="font-size:15px!important; color:#495057; margin-top:-10px!important;">Daily Sales</p>
                      </router-link>
                    </b-col>
                    <b-col md="1 vrhicle">
                      <router-link to="/sales/monthly-sales">
                        <i class="icon-monthly text-center"></i>
                      </router-link>
                    </b-col>
                    <b-col md="2 vrhicle">
                      <router-link to="/sales/monthly-sales">
                        <p class="text-black" style="font-size:22px!important;">{{this.model.monthly}}<p style="font-size:15px!important; color:#495057; margin-top:-10px!important;">Monthly Sales</p>
                      </router-link>
                    </b-col>
                    <b-col md="1 vrhicle">
                      <router-link to="/sales/yearly-sales">
                        <i class="icon-yearly text-center"></i>
                      </router-link>
                    </b-col>
                    <b-col md="2 vrhicle">
                      <router-link to="/sales/yearly-sales">
                        <p class="text-black" style="font-size:22px!important;">{{this.model.yearly}}<p style="font-size:15px!important; color:#495057; margin-top:-10px!important;">Yearly Sales</p>
                      </router-link>
                    </b-col>
                  </b-row>
                </b-col>
                <!--<b-col md="8">
                  <b-card-group class="text-center">
                    <b-card no-body class="sub-card p-1">
                      <b-button variant="light" href="#"><p class="text-black" style="font-size:12px;">Daily Sales</p>
                      <span class="text-vehicle-count">0</span></b-button>
                    </b-card>
                    <div class="sales-order"></div>
                    <b-card no-body class="sub-card p-1">
                      <b-button variant="light" href="#"><p class="text-black" style="font-size:12px;">Monthly Sales</p>
                      <span class="text-vehicle-count">0</span></b-button>
                    </b-card>
                    <div class="sales-order"></div>
                    <b-card no-body class="sub-card p-1">
                      <b-button variant="light" href="#"><p class="text-black" style="font-size:12px;">Yearly Sales</p>
                      <span class="text-vehicle-count">0</span></b-button>
                    </b-card>
                  </b-card-group>-->
                  <!--<b-row>
                    <b-col md="12 mt-3">
                      <a href="#" style="font-size:11px!important; text-align:right!important; color:blue!important;">View Statistics</a>
                    </b-col>
                  </b-row>
                </b-col>-->
              </b-row>
            </b-card>
          </b-col>

          <b-col md="12" class="mt-4">
            <b-card>
              <b-row>
                <b-col md="10">
                    <h3>{{$route.name}}</h3>
                    <b-breadcrumb>
                        <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                        <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                    </b-breadcrumb>
                </b-col>
                <b-col md="2 mt-4">
                  <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToPDF()" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button>
                </b-col>
              </b-row>
              <div class="border-bottom mb-3"></div>
              <b-row class="mt-3 mb-3">
                <b-col md="4">
                  <b-form-input v-model="tableFilter.order_id" v-on:afterHit="doFilter" customQueryParamName="search" placeholder="Order ID"/>
                </b-col>
                <b-col md="4">
                  <b-form-select v-model="tableFilter.company" :options="companyList" />
                </b-col>
                <b-col md="4">
                  <b-form-select v-model="tableFilter.branch" :options="branchList" />
                </b-col>
                <b-button variant="light" style="margin-left:-65px!important; padding-bottom:10px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
                </b-button>
              </b-row>
              <b-row class="mt-3 mb-3">
                <!--<b-col md="4">
                  <b-form-input v-model="tableFilter.requested_by" v-on:afterHit="doFilter" customQueryParamName="search" placeholder="Search by Sales Person"/>
                </b-col>-->
                <b-col md="4">
                  <b-form-input v-model="tableFilter.search_customer" v-on:afterHit="doFilter" customQueryParamName="search" placeholder="Customer"/>
                </b-col>
                <b-col md="4">
                  <b-form-select v-model="tableFilter.statusSalesOrder" :options="statusList" />
                </b-col>
                <b-col md="4">
                  <date-picker v-model="tableFilter.date" type="date" range placeholder="Order Date"></date-picker>
                </b-col>
                <!--<b-col md="3">
                    <b-form-select v-model="tableFilter.branch" :options="branchList" />
                </b-col>
                <b-col md="1">
                    <b-button variant="light" style="margin-left:-85px!important; padding-bottom:6px!important;"disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
                    </b-button>
                </b-col>-->
              </b-row>
              <paginated-table ref="dataTable" :can-delete="false" :can-show="true" :can-download="false" :can-print="false" :can-edit-modal="false" :can-edit="false" :can-reject="true" :can-approve="true" :data-url="apiUrl.salesOrder" :data-key="dataKey" :data-columns="columns" :data-params="['order_id', 'company_uuid', 'branch_uuid', 'search_customer', 'requested_by', 'start_date', 'end_date', 'status']">
              </paginated-table>
            </b-card>
          </b-col>
        </b-row>
    </div>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    export default {
        name: 'sales-order',
        components: {
            PaginatedTable,
            DatePicker
        },
        data () {
            return {
                dataKey: 'sales_order',
                apiUrl: {
                    salesOrder: window.AppConfig.apiUrl + 'sales-order',
                    salesOrderStats: window.AppConfig.apiUrl + 'sales-order-stats',
                    exportSalesOrder: window.AppConfig.apiUrl + 'export-sales-order-general'
                },
                isLoadingBranch: false,
                model: {
                  totalSales: null,
                  daily: null,
                  monthly: null,
                  yearly: null
                },
                columns: [
                    {
                        key: 'orderId',
                        label: 'Order ID',
                        sortable: true
                    },
                    {
                        key: 'customerSales',
                        label: 'Customer',
                        sortable: true
                    },
                    {
                        key: 'company',
                        label: 'Company',
                        sortable: true
                    },
                    {
                        key: 'branch',
                        label: 'Branch',
                        sortable: true
                    },
                    {
                        key: 'requestedBySales',
                        label: 'Sales Person',
                        sortable: true
                    },
                    {
                        key: 'orderDate',
                        label: 'Order Date',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'Status'
                    },
                    {
                        key: 'actionSales',
                        label: ''
                    }
                ],
                companyList: [
                  {
                    value: null,
                    text: 'Company'
                  }
                ],
                branchList: [
                  {
                    value: null,
                    text: 'Branch'
                  }
                ],
                statusList: [
                  {
                    value: null,
                    text: 'Status'
                  },
                  {
                    value: 'Requested',
                    text: 'Requested'
                  },
                  {
                    value: 'Approved',
                    text: 'Approved'
                  },
                  {
                    value: 'Rejected',
                    text: 'Rejected'
                  }
                ],
                tableFilter: {
                  order_id: this.$route.query.order_id,
                  requested_by: this.$route.query.requested_by,
                  search_customer: this.$route.query.search_customer,
                  company_uuid: this.$route.query.company,
                  company: null,
                  branch_uuid: this.$route.query.branch,
                  branch: null,
                  status: this.$route.query.status,
                  statusSalesOrder: null,
                  date: null,
                  start_date: this.$route.query.start_date,
                  end_date: this.$route.query.end_date
                }
            }
        },
        watch: {
          'tableFilter.company' (value) {
            this.getBranch(value)
          },
          'tableFilter.branch' () {
            this.doFilter()
          },
          'tableFilter.order_id' () {
            this.doFilter()
          },
          'tableFilter.search_customer' () {
            this.doFilter()
          },
          'tableFilter.requested_by' () {
            this.doFilter()
          },
          'tableFilter.statusSalesOrder' () {
            this.doFilter()
          },
          'tableFilter.date' (value) {
            if (value !== null && value.length >= 1 && value[0] === null && value[1] === null) {
              this.tableFilter.date = null
              this.doFilter()
            } else {
              this.doFilter()
            }
          }
        },
        mounted() {
          this.getCompany()
          this.getSalesOrderStats()
        },
        methods: {
          doFilter () {
            this.tableFilter.order_id = this.tableFilter.order_id
            this.tableFilter.requested_by = this.tableFilter.requested_by
            this.tableFilter.search_customer = this.tableFilter.search_customer
            this.tableFilter.company_uuid = this.tableFilter.company
            this.tableFilter.branch_uuid = this.tableFilter.branch
            this.tableFilter.status = this.tableFilter.statusSalesOrder
            this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
            this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
            this.$refs.dataTable.doFilter(this.tableFilter)
          },
          doExportToPDF () {
            let url = this.apiUrl.exportSalesOrder + '?token=' + this.$store.getters['account/tokens'].access_token
            if (this.tableFilter.order_id !== undefined && this.tableFilter.order_id !== null) {
              url += '&order_id=' + this.tableFilter.order_id
            }
            if (this.tableFilter.search_customer !== undefined && this.tableFilter.search_customer !== null) {
              url += '&search_customer=' + this.tableFilter.search_customer
            }
            if (this.tableFilter.company_uuid !== undefined && this.tableFilter.company_uuid !== null) {
              url += '&company_uuid=' + this.tableFilter.company_uuid
            }
            if (this.tableFilter.branch_uuid !== undefined && this.tableFilter.branch_uuid !== null) {
              url += '&branch_uuid=' + this.tableFilter.branch_uuid
            }
            if (this.tableFilter.status !== undefined && this.tableFilter.status !== null) {
              url += '&status=' + this.tableFilter.status
            }
            if (this.tableFilter.date !== null) {
              url += '&start_date=' + this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
            }
            window.open(url)
          },
          getSalesOrderStats () {
            this.$http.get(this.apiUrl.salesOrderStats).then(response => {
              this.model.totalSales = response.data.totalSales
              this.model.daily = response.data.daily.daily
              this.model.monthly = response.data.monthly.monthly
              this.model.yearly = response.data.yearly.yearly
            })
          },
          getCompany () {
            this.$http.get(window.AppConfig.apiUrl + 'company').then(response => {
              response.data._embedded.company.forEach(data => {
                this.companyList.push({
                  value: data.uuid,
                  text: data.name
                })
              })
            })
          },
          getBranch (companyUuid = null) {
            this.isLoadingBranch = true
            if (companyUuid != null && this.tableFilter.company != null) {
              this.doFilter()
              this.tableFilter.branch_uuid = this.tableFilter.branch
              this.tableFilter.branch = null
              this.tableFilter.company_uuid = this.tableFilter.company
            } else {
              this.doFilter()
              this.tableFilter.branch = null
              this.tableFilter.company = null
            }
            this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1').then(response => {
              this.branchList = []
              this.isLoadingBranch = false
              response.data._embedded.branch.forEach(data => {
                this.branchList.push({
                  value: data.uuid,
                  text: data.name
                })
              })
            }).catch(error => {
              window.consoleLog(error)
              this.isLoadingBranch = false
            })
          },
        }
    }
</script>